import React from 'react'

const Form: React.FC<{ id: string }> = ({ id }) => (
  <div id={id} {...{ 'data-name': 'Unified' }}>
    <div className="localAccount" aria-label="Sign in with your existing account" role="form">
      <div className="intro">
        <h2>Sign in with your existing account</h2>
      </div>
      <div className="error pageLevel" aria-hidden="false">
        <p role="alert">An error</p>
      </div>
      <div className="entry">
        <div className="entry-item">
          <label htmlFor="signInName"> Email Address </label>
          <div className="error itemLevel" aria-hidden="false">
            <p role="alert">An error</p>
          </div>
          <input
            type="email"
            id="signInName"
            name="Username or email address"
            pattern="^[a-zA-Z0-9.!#$%&amp;’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
            placeholder="Email Address"
            value=""
            tabIndex={1}
            autoComplete="off"
            style={{
              backgroundImage:
                "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII=')",
            }}
          />
        </div>
        <div className="entry-item">
          <div className="password-label">
            <label htmlFor="password">Password</label>
            <a
              id="forgotPassword"
              tabIndex={2}
              href="/mettlephilliptestauth.onmicrosoft.com/B2C_1_SignUp_SignIn_Default/api/CombinedSigninAndSignup/forgotPassword?csrf_token=aktWOVRoejIyVmRLcEhQdlFIUjlSZDZzVjc1TGgyRTF0bnBDMkl6ZTFhTDVaenJyWXRpMWpWTlNGN1BscytnbkxMdDE2MndYb3JjZmVqMXJSSjJyMEE9PTsyMDIwLTEyLTE3VDE2OjI2OjA3LjU4ODgwNVo7MU96M1JHc0JnVitJRnAzKzBIdHlYZz09O3siT3JjaGVzdHJhdGlvblN0ZXAiOjF9&amp;tx=StateProperties=eyJUSUQiOiIwMThjZTJhYi0zNmY2LTQ4YzMtYjljZS01ZDEzNDQzNTA0ZGEifQ&amp;p=B2C_1_SignUp_SignIn_Default"
            >
              Forgot your password?
            </a>
          </div>
          <div
            className="error itemLevel"
            aria-hidden="false"
            style={{
              display: 'none',
            }}
          >
            <p role="alert">An error</p>
          </div>
          <input
            type="password"
            id="password"
            name="Password"
            placeholder="Password"
            tabIndex={1}
            style={{
              backgroundImage:
                "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII=')",
            }}
          />
        </div>
        <div
          className="working"
          style={{
            display: 'block',
          }}
        ></div>
        <div className="buttons">
          <button id="next" tabIndex={1}>
            Sign in
          </button>
        </div>
      </div>

      <div className="divider">
        <h2>OR</h2>
      </div>
      <div className="create">
        <p>
          Don't have an account?
          <a
            id="createAccount"
            tabIndex={1}
            href="/mettlephilliptestauth.onmicrosoft.com/B2C_1_SignUp_SignIn_Default/api/CombinedSigninAndSignup/unified?local=signup&amp;csrf_token=aktWOVRoejIyVmRLcEhQdlFIUjlSZDZzVjc1TGgyRTF0bnBDMkl6ZTFhTDVaenJyWXRpMWpWTlNGN1BscytnbkxMdDE2MndYb3JjZmVqMXJSSjJyMEE9PTsyMDIwLTEyLTE3VDE2OjI2OjA3LjU4ODgwNVo7MU96M1JHc0JnVitJRnAzKzBIdHlYZz09O3siT3JjaGVzdHJhdGlvblN0ZXAiOjF9&amp;tx=StateProperties=eyJUSUQiOiIwMThjZTJhYi0zNmY2LTQ4YzMtYjljZS01ZDEzNDQzNTA0ZGEifQ&amp;p=B2C_1_SignUp_SignIn_Default"
          >
            Sign up now
          </a>
        </p>
      </div>
    </div>
  </div>
)

export default Form
